import { gluerUniqueFlagKey, gluerUniqueFlagValue } from './constants';
import runtimeVar from './runtimeVar';
import unsubscribe, { modelToCallbacksMap, callbackToModelsMap } from './unsubscribe';
import { isArray } from '../tools';
export var callbackCount = {
  num: 0
};
var subscribe = function subscribe(deps, cb) {
  var callWhenSub = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var noCallbackWrapper = arguments.length > 3 ? arguments[3] : undefined;
  if (!isArray(deps)) {
    throw new Error("Error: the first param must be array\uFF01".concat(deps));
  }
  var callback = cb;
  if (!noCallbackWrapper) {
    callback = function callback() {
      return cb.apply(void 0, arguments);
    };
  }
  if (typeof callback !== 'function') {
    throw new Error("Error: the second param muse be function! ".concat(callback));
  }
  var copyDeps = deps;
  var initialDepsValue = [];
  for (var i = 0; i < copyDeps.length; i += 1) {
    var dep = copyDeps[i];
    if (typeof dep !== 'function') {
      console.trace();
      throw new Error("Error: dependency ".concat(dep, ", is not function."));
    }
    if (dep[gluerUniqueFlagKey] !== gluerUniqueFlagValue) {
      console.error("Warning: dependency ".concat(dep, ", is not defined by gluer. Please check it!"));
    }
    initialDepsValue.push(dep());
  }
  ;
  var setDeps = copyDeps.length !== 0;
  if (setDeps) {
    callback.__id = callbackCount.num;
    callbackCount.num += 1;
    callback.__bind_type = runtimeVar.runtimeBindType;
    callback.__listen_type = runtimeVar.runtimeListenType;
    var l = copyDeps.length;
    for (var _i = 0; _i < l; _i += 1) {
      var _dep = copyDeps[_i];
      if (modelToCallbacksMap.has(_dep)) {
        var set = modelToCallbacksMap.get(_dep);
        set === null || set === void 0 ? void 0 : set.add(callback);
      } else {
        modelToCallbacksMap.set(_dep, new Set([callback]));
      }
    }
    callbackToModelsMap.set(callback, new Set(copyDeps));
  }
  if (callWhenSub) {
    callback.apply(void 0, initialDepsValue);
  }
  var unsubCallback = function unsubCallback() {
    if (setDeps) {
      unsubscribe(copyDeps, callback);
    }
  };
  unsubCallback.__id = callback.__id;
  return unsubCallback;
};
export default subscribe;